import { t } from '@lingui/core/macro';
import { useState } from 'react';

import ClosedEyeIcon from '@/assets/svg/bx-eye-closed.svg?react';
import OpenEyeIcon from '@/assets/svg/bx-eye-open.svg?react';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupTextInput,
} from '@/components/Form/inputs/InputGroup';
import type { TextInputProps } from '@/components/Form/inputs/TextInput';
import { maxPasswordLength } from '@/constants';

export type PasswordInputProps = Omit<TextInputProps, 'className'> & {
  className?: string;
  size?: 'small' | 'medium' | 'large';
};

const PasswordInput = ({ className, disabled, size = 'large', ...rest }: PasswordInputProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <InputGroup size={size} className={className}>
      <InputGroupTextInput
        {...rest}
        type={isVisible ? 'text' : 'password'}
        size={size}
        disabled={disabled}
        maxLength={maxPasswordLength}
      />
      <InputGroupAddon align="inline-end">
        <InputGroupButton
          disabled={disabled}
          size={size === 'large' ? 'icon' : 'icon-small'}
          shape="round"
          aria-label={isVisible ? t`Hide password` : t`Show password`}
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? <OpenEyeIcon /> : <ClosedEyeIcon />}
        </InputGroupButton>
      </InputGroupAddon>
    </InputGroup>
  );
};

export default PasswordInput;
